import { a } from '@react-spring/three'
import { Text } from '@react-three/drei'

export const AnimatedText = a(Text)

export function getRandomNumber(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1) ) + min
}
